<template>
    <el-dialog
        width="600px"
        title="规格包装"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form ref="formData" :model="formData" :rules="rules" size="mini" label-width="130px">

            <el-form-item label="包装物-名称：">
                <el-input v-model="formData.wrappage" style="width: 200px;margin-right:20px;" size="mini"
                          placeholder="请输入包装物"></el-input>
            </el-form-item>
            <el-form-item label="包装物-长(cm)：">
                <el-input-number
                    v-model="formData.wrappage_long"
                    style="width: 150px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入包装物-长(cm)"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="包装物-宽(cm)：">
                <el-input-number
                    v-model="formData.wrappage_wide"
                    style="width: 150px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入包装物-宽(cm)"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="包装物-高(cm)：">
                <el-input-number
                    v-model="formData.wrappage_height"
                    style="width: 150px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入包装物-高(cm)"
                >
                </el-input-number>
            </el-form-item>

            <el-form-item label="包装物链接：">
                <el-input v-model="formData.wrappage_link" style="width: 300px;margin-right:20px;" size="mini"
                          placeholder="请输入包装物-链接"></el-input>
            </el-form-item>
            <el-form-item label="采购规格备注：" prop="remark">
                <el-input
                    v-model="formData.purchase_specification_remark"
                    :autosize="{ minRows: 2, maxRows: 5 }"
                    type="textarea" style="width: 300px;"
                    placeholder="请输入采购规格备注"
                ></el-input>
            </el-form-item>

        </el-form>


        <el-row style="margin-top:17px; ">
            <el-button style="float:right;margin-left:6px;" size="mini" type="danger" plain @click="handleClose()">关 闭
            </el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm()" :loading="loading">修 改
            </el-button>
        </el-row>
    </el-dialog>

</template>

<script>
    import * as api from '@/api/advAnalys/advAnalys.js'

    export default {
        name: 'specificationPackageModal',
        data() {
            return {
                visible: false,
                loading: false,
                formData: {},
                rules: {},
            }
        },
        methods: {
            openModal(data) {
                const tempData =  JSON.parse(JSON.stringify(data))
                // tempData.wrappage_long = tempData.long
                // tempData.wrappage_wide = tempData.wide
                // tempData.wrappage_height = tempData.height
                // tempData.wrappage_weight = tempData.weight
                this.formData = tempData
                this.visible = true
            },
            submitForm() {
                this.loading = true
                this.$refs['formData'].validate(valid => {
                    if (valid) {
                        api.cost_analysis_personal_update_field({
                            id: this.formData.cost_analysis_id,
                            wrappage: this.formData.wrappage,
                            wrappage_long: this.formData.wrappage_long,
                            wrappage_wide: this.formData.wrappage_wide,
                            wrappage_height: this.formData.wrappage_height,
                            wrappage_link: this.formData.wrappage_link,
                            purchase_specification_remark: this.formData.purchase_specification_remark,
                        }).then(res => {
                            this.loading = false
                            if (res.code === 0) {
                                this.$message({message: '修改成功', type: 'success'})
                                this.handleClose(true)
                            } else {
                                this.$message({type: 'error', message: res.message})
                            }
                        }).catch(() => {
                            this.loading = false
                            this.$message({type: 'error', message: '网络出现问题，请刷新页面！'})
                        })
                    } else {
                        this.loading = false
                        this.$message({type: 'error', message: '请填写相应内容！'})
                    }
                })
            },

            // 关闭弹窗
            handleClose(isshow = false) {
                this.visible = false
                this.$emit('close-callback', isshow)
            }
        }
    }
</script>

<style scoped>

</style>
